import { render, staticRenderFns } from "./TabsMenu.vue?vue&type=template&id=515efd3a&"
import script from "./TabsMenu.vue?vue&type=script&lang=js&"
export * from "./TabsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports